<template>
  <div :class="containerClassObject">
    <div v-if="!hideLabel" :id="`${id}-label`" class="wm-field-label">
      <label v-if="label" :for="id" :class="{required: required}" v-html="label"/>
    </div>
    <div class="wm-field-input">
      <input
        :id="id"
        :type="type"
        :name="name"
        :value="value"
        :class="{ error: $v.$error }"
        :placeholder="placeholder"
        :maxlength="maxlength"
        :readonly="readonly"
        :disabled="disabled"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
      >
    </div>
    <validation-message-list
      v-if="!disabled || !readonly"
      :$v="$v"
      :property-path="name"
      :translation-name-space="validationMessageTranslationNameSpace"
    />
  </div>
</template>

<script>
import $ from 'jquery'
import 'bower/intl-tel-input/lib/libphonenumber/build/utils'
import 'bower/intl-tel-input'
import '../../../../vendor/xc-website/static/bower_components/intl-tel-input/build/css/intlTelInput.css'
import InputField from './InputField'

export default {
  name: 'IntlTelInputField',
  extends: InputField,
  data () {
    return {
      $field: null
    }
  },
  mounted () {
    this.initPlugin()
  },
  beforeDestroy () {
    this.destroyPlugin()
  },
  beforeUpdate: function () {
    this.destroyPlugin()
  },
  updated: function () {
    this.initPlugin()
  },
  methods: {
    destroyPlugin () {
      $(this.$el).intlTelInput('destroy')
    },
    initPlugin () {
      const $field = $('#' + this.id)
      $field.intlTelInput({
        onlyCountries: ['be', 'de', 'nl'],
        preferredCountries: ['nl'],
        autoFormat: false,
        allowExtensions: false,
        autoPlaceholder: true,
        defaultCountry: 'nl',
        ipinfoToken: '',
        nationalMode: true
      })
      this.$field = $field
    },
    validate () {
      return this.$field.val() ? this.$field.intlTelInput('isValidNumber') && /^[0-9+]+$/.test(this.$field.val()) : true
    },
    onInput (e) {
      this.$emit('input', this.validate() ? this.$field.intlTelInput('getNumber') : e.target.value)
    }
  }
}
</script>

<style scoped>
  input {
    padding-left: 3.5em !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/forms/fields/IntlTelInputField.vue